import { setSelectedTenant as setSelectedTenantApiHeader, apiSlice } from '@client/api';
import {
  selectAllowedTenants,
  SelectedTenant,
  selectSelectedTenant,
  setSelectedTenant,
  AppDispatch,
} from '../../redux';
import { useAppSelector } from '../useAppSelector';
import { useDispatch } from 'react-redux';

export const useTenants = () => {
  const allowedTenants = useAppSelector(selectAllowedTenants);
  const selectedTenant = useAppSelector(selectSelectedTenant);
  const dispatch = useDispatch<AppDispatch>();

  const handleSetSelectedTenant = async (tenant: SelectedTenant) => {
    // Set tenant header only if tenant is an object with id
    if (tenant && typeof tenant === 'object' && 'id' in tenant && tenant.id) {
      setSelectedTenantApiHeader(tenant.id);
    } else {
      // Reset tenant header when "All" is selected or no tenant
      setSelectedTenantApiHeader(null);
    }

    // Update local storage and redux
    window.localStorage.setItem('exio.selectedTenant', JSON.stringify(tenant));
    dispatch(setSelectedTenant(tenant));
    // Reset API cache when tenant changes to prevent data leakage between tenants
    dispatch(apiSlice.util.resetApiState());
    // Refetch session to get updated user/person data for the new tenant
    dispatch(apiSlice.endpoints.getAuthSession.initiate() as never);

    // Invalidate all permission caches after tenant change
    dispatch(apiSlice.util.invalidateTags(['UserPermissions']));
    // Immediately refetch permissions to ensure they're available
    dispatch(apiSlice.endpoints.getUserPermissions.initiate());
  };

  return {
    allowedTenants,
    setSelectedTenant: handleSetSelectedTenant,
    selectedTenant: selectedTenant,
  };
};
